export default {
  PingToServer(onsuccess, onfailed) {
    return {
      onsuccess : onsuccess,
      onfailed : onfailed
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/system/ping/helper/request.props.js